<template>
    <div class="pane-title-container">
        <div class="pane-title">
            <div class="title" v-if="lang !== 'en'">{{ title }}</div>
        </div>
        <div class="pane-subtitle" :class="{ 'en-bold': lang === 'en' }">
            {{ subTitle }}
        </div>
    </div>
</template>

<script>
export default {
    props: ['title', 'subTitle'],
    name: "PaneTitle",
    computed: {
        lang() {
            return this.$i18n.locale;
        }
    }
}
</script>
<style scoped lang="less">
.pane-title {

    display: flex;
    align-items: center;
    justify-content: center;

    .title {
        font-size: 2rem;
        font-weight: bold;
        margin: 0 1.5rem;
        // line-height: 1;
    }

}

.pane-title-container {
    .pane-subtitle {
        text-align: center;
        font-size: 1.25rem;
        color: var(--tertiary-text-color);
        line-height: 1;

        &.en-bold {
            font-weight: bold;
            font-size: 2rem;
            color: var(--default-text-color);
        }
    }
}
</style>